import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { noPastDateValidator, endDateAfterStartDateValidator } from '../../pages/assisted-booking/validator';

@Component({
  selector: 'app-extra-service-flight',
  templateUrl: './extra-service-flight.component.html',
  styleUrls: ['./extra-service-flight.component.scss']
})
export class ExtraServiceFlightComponent implements OnInit {
  user: IUser | undefined
  private toastState = {
  startPast: false,
  endPast: false,
  endBeforeStart: false
};
  form = new FormGroup({
    from: new FormControl('', [Validators.required]),
    to: new FormControl('', [Validators.required]),
    travel_end: new FormControl('', [Validators.required, noPastDateValidator()]),
    travel_start: new FormControl('', [Validators.required, noPastDateValidator()]),
    number_of_travelers: new FormControl('', [Validators.required]),
    additional_requests: new FormControl('', []),
    cabin_preference: new FormControl('', [Validators.required]),
  },
       {
          validators: endDateAfterStartDateValidator('travel_start', 'travel_end')
        });
  locationName: any;
  booking: any;
  minDate: any;

  loading: boolean = false
  endDate: any;

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,


  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser

    this.booking = this.options.initialState?.booking
      const ctrlStart = this.form.get('travel_start');
    const ctrlEnd = this.form.get('travel_end');

    ctrlStart?.valueChanges.subscribe(() => {
      if (ctrlStart.hasError('pastDate')) {
        if (!this.toastState.startPast) {
          this.toastr.error(
            'No past date allowed. Please enter the current date or a future date.'
          );
          this.toastState.startPast = true;
          this.form.get('travel_start')?.setValue('');
        }
      } else {
        this.toastState.startPast = false;
      }
    });
      ctrlEnd?.valueChanges.subscribe(() => {
    if (ctrlEnd.hasError('pastDate')) {
      if (!this.toastState.endPast) {
        this.toastr.error(
          'No past date allowed. Please enter today or a future date for End Date.'
        );
        this.toastState.endPast = true;
        this.form.get('travel_end')?.setValue('');
      }
    } else {
      this.toastState.endPast = false;
    }
      });
     this.form.valueChanges.subscribe(() => {
    if (this.form.hasError('endBeforeStart')) {
      if (!this.toastState.endBeforeStart) {
        this.toastr.error(
          'Travel end date cannot be earlier than the travel start date.'
        );
        this.toastState.endBeforeStart = true;
        this.form.get('travel_start')?.setValue('');
        this.form.get('travel_end')?.setValue('');
      }
    } else {
      this.toastState.endBeforeStart = false;
    }
  });
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
    // this.minDate.setDate(this.minDate.getDate());

  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.from.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.to.setValue(s);

  }

  getDate(event: any) {
    this.endDate = event.value;
  }

  submit() {
    this.loading = true
    const {from, to, additional_requests, number_of_travelers, travel_end, travel_start, cabin_preference} = this.form.value;

    const payload:any = {
      from,
      to,
      additional_requests,
      number_of_travelers,
      travel_end,
      cabin_preference,
      travel_start,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking ? this.booking : 'null'

    }
    if (this.booking !== null) {
      this.service.createExtraServiceFlight(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })
    } else {
      delete payload.booking
      this.service.createExtraServiceFlight(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false


          // this.bsModalRef.hide()
      })

    }
  }

}
